<template>
    <div>
        <myPage>
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                    <el-button type="primary" size="small" @click="openAdd()" icon="el-icon-edit">新建</el-button>
                    <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="list()"></el-button>
                    <el-button size="small" @click="exportExcel" :title="$t('export')" icon="el-icon-download"></el-button>
                </el-button-group>
                <div class="f-bd f14 text-nowrap">{{$t('add_time')}}{{$t('x_mh')}}</div>
                <div class="mg-right5 mg-top5"><myDatePicker v-model="search.datearea_id" @onChange="onDateChange"></myDatePicker></div>
                <div class="mg-right5 mg-top5">
                    <el-input size="small" v-model="search.vendor_cname">
                        <span slot="prepend">{{$t('cname')}}{{$t('x_yd')}}</span>
                    </el-input>
                </div>
                <div class="mg-top5"><el-button size="small" @click="list()">{{$t('list')}}</el-button></div>
            </div>
            <div class="fillw fillh">
                <el-table class="el-table--border" :data="listData" style="width: 100%" height="100%">
                    <el-table-column prop="vendor_id" :label="listHeader.vendor_id" width="100px"></el-table-column>
                    <el-table-column prop="vendor_cname" :label="listHeader.vendor_cname" min-width="180px"></el-table-column>
                    <el-table-column min-width="150px" prop="cr_cat_cdesc">
                        <template slot-scope="scope" slot="header">
                            <myDropdown :title="listHeader.cr_cat_cdesc" :list="cr_cat" v-model="search.cr_cat"
                                        title_class="f12 f-blue" key_name="value" value_name="key" @onChange="list()"></myDropdown>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="180px" :label="listHeader.cr_qty">
                        <div class="flex-box nopadding" slot-scope="scope">
                            <span class="f-bd f-red f14 mg-right10">{{scope.row.cr_qty * 1}}</span>
                            <a class="link mg-right10" @click="openSn(scope.row)">明细</a>
                            <el-popover placement="bottom">
                                <div class="flex-box nopadding hand" slot="reference">
                                    <a class="link">管理</a>
                                </div>
                                <div class="flex-box nopadding">
                                    <el-input size="small" class="width-200 mg-right5" v-model="scope.row.cr_qty_upd">
                                        <span slot="prepend">数量</span>
                                    </el-input>
                                    <el-button size="small" type="primary" @click="addCrQty(scope.row,'in')">确认增额</el-button>
                                    <el-button size="small" type="warning" @click="addCrQty(scope.row,'out')">确认减额</el-button>
                                </div>
                            </el-popover>
                        </div>
                    </el-table-column>
                    <el-table-column min-width="100px" :label="listHeader.org_qty">
                        <div slot-scope="scope">
                            <span class="f14 mg-right3">{{scope.row.org_qty * 1}}家</span>
                        </div>
                    </el-table-column>
                    <el-table-column min-width="120px" prop="vendor_status_cdesc">
                        <template slot-scope="scope" slot="header">
                            <myDropdown :title="listHeader.vendor_status_cdesc" :list="vendor_status" v-model="search.vendor_status"
                                        title_class="f12 f-blue" key_name="value" value_name="key" @onChange="list()"></myDropdown>
                        </template>
                    </el-table-column>
                    <el-table-column prop="add_time" :label="listHeader.add_time" min-width="150px"></el-table-column>
                    <el-table-column fixed="right" :label="$t('op')" width="60px">
                        <template slot-scope="scope">
                            <a class="link" @click="openSave(scope.row.vendor_id)">{{$t('info')}}</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer">
                <myPager slot="footer" :limit="search.limit" @onLimitChange="onLimitChange"
                         v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
            </div>
        </myPage>
        <myDrawer v-model="show_subview">
            <router-view></router-view>
        </myDrawer>
    </div>
</template>

<script>
    import myDatePicker from "../../../components/myDatePicker"
    import myPager from '../../../components/myPager'
    import myDropdown from '../../../components/myDropdown'
    import myImgshow from '../../../components/myImgshow'
    export default {
        name:'vendor-code',
        components:{
            myDatePicker,
            myPager,
            myDropdown,
            myImgshow
        },
        data:function(){
            const listHeader = {
                vendor_id: 'ID',
                vendor_cname: this.$t('cname'),
                cr_cat_cdesc: '信誉消费模式',
                cr_qty: '信誉额度',
                org_qty: '签约客户数',
                vendor_status_cdesc: this.$t('status'),
                add_time: this.$t('add_time')
            };
            return{
                self:this,
                show_subview:false,
                relist:false,
                search:{
                    search_url: "vendor-code/list",
                    datearea_id:0,//如果大于0 mounted 要删除date_fr date_to
                    date_fr: '',
                    date_to: '',
                    page: 1,
                    limit: 30,
                    pageSize: 0,
                    vendor_cname: '',
                    vendor_status: ''
                },
                listHeader,//表结构
                listData: [],
                totalData: {
                    total: 0,//总行数
                },
                vendor_status:[
                    {
                        key:'',
                        value:this.$t('all')
                    }
                ],
                cr_cat:[
                    {
                        key:'',
                        value:this.$t('all')
                    }
                ],
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();

            this.$base.listPageInit(this,()=>{
                this.getLoad();
            });
        },
        methods:{
            onDateChange: function(data){
                this.search.date_fr = data[0];
                this.search.date_to = data[1];
            },
            onPagerChange: function () {
                this.list(true);
            },
            onLimitChange: function (limit) {
                this.search.limit = limit;
                this.list();
            },
            getLoad: function () {
                this.$base.showLoading();
                this.$request.sendPost("vendor-code/before-list",{},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.cr_cat = this.cr_cat.concat(data.cr_cat);
                        this.vendor_status = this.vendor_status.concat(data.vendor_status);
                        this.list()
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            list: function (change_page) {
                this.$base.list(this, change_page);
            },
            exportExcel: function(){
                this.$base.exportExcel(this);
            },
            openAdd:function () {
                this.$base.linkTo("/vendor/code/save",{op:'add'});
            },
            openSave:function (id) {
                this.$base.linkTo("/vendor/code/save",{op:'upd', id});
            },
            openSn:function (item) {
                this.$base.linkTo("/vendor/code/crsn",{vendor_id:item.vendor_id,vendor_cname:item.vendor_cname});
            },
            //move_type in 增额 out 减额
            addCrQty: function(item,move_type){
                if(item.cr_qty_upd == ''){
                    this.$base.msgErr('请输入信誉值');
                    return;
                }

                var data = {
                    vendor_id: item.vendor_id,
                    cr_qty: item.cr_qty_upd
                }
                this.$base.showLoading();
                var url = move_type == 'in'?"vendor-code/add-cr-qty":"vendor-code/clear-cr-qty";
                this.$request.sendPost(url,data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.$base.msgSuccess(error.errmsg);
                        item.cr_qty = data;
                        item.cr_qty_upd = '';
                        this.$base.bodyClick();
                    }
                    else{
                        this.$base.msgErr(error.errmsg);
                    }
                });
            },
        },
        watch:{
            //界面重新加载数据
            relist:function (newVal,oldVal) {
                if(newVal){
                    this.list(true);
                    this.relist = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/vendor/code/list.vue